import Vue from 'vue'
import VueI18n from 'vue-i18n'
import {SHARED} from '@/constants/constants'
// en stays in the main bundle: it is the fallback for any key another language is missing
import en from '@/locales/en.json'
//import th from '@/locales/th.json'
Vue.use(VueI18n)

const i18n = new VueI18n({
    locale: 'en',
    fallbackLocale: SHARED.FALLBACK_LANGUAGE,
    messages: {en}
})

// Other languages download as their own file, only when used
const lazyMessages = {
    bd: () => import(/* webpackChunkName: "lang-bd" */ '@/locales/bd.json'),
    ta: () => import(/* webpackChunkName: "lang-ta" */ '@/locales/ta.json')
}
const loaded = {en: true}

export function loadLanguage(lang) {
    if (loaded[lang] || !lazyMessages[lang]) return Promise.resolve()
    return lazyMessages[lang]().then(messages => {
        i18n.setLocaleMessage(lang, messages.default || messages)
        loaded[lang] = true
    })
}

export default i18n
